import React, { MouseEvent, useEffect } from 'react'
import { Handle, Position } from 'reactflow'
import NodeTemplate from '../../base/NodeTemplate'
import { SaveTimeseriesConfiguration } from './SaveTimeseriesForm'
import { BaseNodeProps } from '../../base/types'

const SaveTimeseries = React.memo(
  ({ data, isConnectable }: BaseNodeProps<SaveTimeseriesConfiguration>) => {
    const title = 'Save timeseries'
    useEffect(() => {}, [])
    return (
      <>
        <Handle
          type="target"
          position={Position.Left}
          isConnectable={isConnectable}
        />
        <NodeTemplate icon={'database'} title={title} name={data.name} />
        <Handle
          type="source"
          position={Position.Right}
          id="a"
          isConnectable={isConnectable}
        />
      </>
    )
  }
)

export default SaveTimeseries
